<script lang="ts" setup>
defineProps<{
    expanded?: boolean
}>()
</script>

<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="10" viewBox="0 0 16 10" fill="currentColor" :class="{ 'is-expanded': expanded }">
        <path
            d="M15.7609 1.24911L15.2609 0.749115C15.1044 0.593093 14.8924 0.505486 14.6714 0.505486C14.4504 0.505486 14.2385 0.593093 14.0819 0.749115L8.38794 6.44312L2.68794 0.743118C2.53129 0.587339 2.31936 0.499893 2.09844 0.499893C1.87752 0.499893 1.66558 0.587339 1.50894 0.743118L1.00894 1.24312C0.852672 1.39951 0.764893 1.61154 0.764893 1.83262C0.764893 2.0537 0.852672 2.26573 1.00894 2.42212L7.79594 9.23312C7.95004 9.39654 8.16244 9.4925 8.38694 9.50011C8.61073 9.49198 8.82232 9.39606 8.97594 9.23312L15.7559 2.44012C15.8342 2.36117 15.8961 2.2675 15.9379 2.16452C15.9798 2.06154 16.0009 1.95128 15.9999 1.84012C16.0018 1.61922 15.9158 1.40663 15.7609 1.24911Z"
        />
    </svg>
</template>

<style scoped>
svg {
    transition: transform 0.3s ease;
}

svg.is-expanded {
    transform: rotate(180deg);
}
</style>
